<script lang="ts">
  import type {
    BetfairMarket,
    LayoutPreference,
    MarketOverrounds
  } from '$types/races';
  import {
    getBetfairMarketTypeFromLayoutPreference,
    selectedRaceHasSP
  } from '$utils/race';
  import type { Readable } from 'svelte/store';
  import BetfairMarketMatchedCell from './BetfairMarketMatchedCell.svelte';
  import MarketOverroundCell from './MarketOverroundCell.svelte';
  import { selectedRaceId } from '$utils/navigation';
  import { currentEventData } from './TextInputCell.svelte';

  export let marketOverrounds: MarketOverrounds;
  export let computedLayoutPreferences: LayoutPreference[];
  export let betfairMarketTypes: ('win' | 'place')[];
  export let betfairTotalMatchedStores: {
    win: Readable<BetfairMarket> | undefined;
    place: Readable<BetfairMarket> | undefined;
  };
  export let bestPriceOverrounds: {
    fixedWin: number;
    fixedPlace: number;
  };

  $: $selectedRaceId && currentEventData.set(null);
</script>

<th
  class="z-10 cursor-pointer border-r bg-gray-50 pr-4 text-left text-xs font-medium text-gray-900 md:sticky md:left-0"
/>

<!-- show sp first if there is one -->
{#if $selectedRaceHasSP}
  {#each betfairMarketTypes as betfairMarketType}
    {@const betfairMarketStore = betfairTotalMatchedStores?.[betfairMarketType]}
    {#if betfairMarketStore}
      <BetfairMarketMatchedCell {betfairMarketStore} />
    {/if}
  {/each}
{/if}
{#each computedLayoutPreferences as layoutPreference}
  {@const bookmakerMarketType =
    layoutPreference.type === 'FIXED_WIN' ||
    layoutPreference.type === 'BEST_PRICE_WIN'
      ? 'fixedWin'
      : 'fixedPlace'}
  {#if (layoutPreference.type === 'BEST_PRICE_WIN' || layoutPreference.type === 'BEST_PRICE_PLACE') && layoutPreference.bookmaker !== 'Betfair'}
    {@const overround = bestPriceOverrounds?.[bookmakerMarketType]?.toFixed(0)}
    <td colspan="4" class="border px-1 py-1 font-medium text-gray-700">
      {#if overround !== '0'}
        {overround}%
      {/if}
    </td>
  {:else if layoutPreference.bookmaker === 'Betfair'}
    {#if !$selectedRaceHasSP}
      {@const betfairMarketType =
        getBetfairMarketTypeFromLayoutPreference(layoutPreference)}
      {#if betfairMarketType}
        {@const betfairMarketStore =
          betfairTotalMatchedStores?.[betfairMarketType]}
        {#if betfairMarketStore}
          <BetfairMarketMatchedCell {betfairMarketStore} />
        {:else}
          <td />
        {/if}
      {/if}
    {:else if layoutPreference.type === 'FIXED_WIN_FLUCS' || layoutPreference.type === 'FIXED_PLACE_FLUCS'}
      <td />
    {/if}
  {:else if layoutPreference.type === 'FIXED_WIN' || layoutPreference.type === 'FIXED_PLACE'}
    {@const overround = layoutPreference.bookmaker
      ? marketOverrounds.get(layoutPreference.bookmaker)?.[bookmakerMarketType]
      : undefined}
    {#if !overround}
      <td />
    {:else}
      <MarketOverroundCell {overround} {layoutPreference} />
    {/if}
  {:else if layoutPreference.type === 'TEXT'}
    <MarketOverroundCell {layoutPreference} />
  {:else}
    <td />
  {/if}
{/each}
